export default "__VITE_ASSET__C_GGs_j4__"